// extracted by mini-css-extract-plugin
export default {"breadcrumbSeperator":"SearchBreadCrumb-module__breadcrumbSeperator___3vJnv","breadcrumbs":"SearchBreadCrumb-module__breadcrumbs___MfTW3"};